export type ThemeName = 'verde' | 'rosso' | 'blu';

const STORAGE_KEY = 'vvf.theme';
const DARK_KEY = 'vvf.dark';

export function getTheme(): ThemeName {
  return (localStorage.getItem(STORAGE_KEY) as ThemeName) ?? 'verde';
}

export function setTheme(name: ThemeName): void {
  localStorage.setItem(STORAGE_KEY, name);
  applyTheme();
  window.dispatchEvent(new CustomEvent('vvf-theme-change'));
}

export function isDarkMode(): boolean {
  return localStorage.getItem(DARK_KEY) === 'true';
}

export function toggleDarkMode(): void {
  localStorage.setItem(DARK_KEY, (!isDarkMode()).toString());
  applyTheme();
  window.dispatchEvent(new CustomEvent('vvf-theme-change'));
}

export function applyTheme(): void {
  const theme = getTheme();
  const body = document.body;
  body.classList.remove('theme-verde', 'theme-rosso', 'theme-blu');
  body.classList.add(`theme-${theme}`);
  body.classList.toggle('dark-mode', isDarkMode());
}
